import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { getTaggedNoteText } from '@mummssoftware/utils/utils';
import { styles } from '../../../utils';
import defaults from '../../../translations/en.json';
export const BereavementNotesPDF = ({
  bereavementNotes
}) => /*#__PURE__*/React.createElement(View, null, bereavementNotes && bereavementNotes.length && ( /*#__PURE__*/React.createElement(View, {
  style: [styles.width50, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.fontWeightBold, styles.fontSizeTenPt, styles.pYPointOneCm]
}, defaults.relatedNotes), /*#__PURE__*/React.createElement(View, {
  style: styles.paddingLeftPointTwoCm
}, bereavementNotes.map(note => /*#__PURE__*/React.createElement(Text, {
  key: note.id,
  style: [styles.fontFamilyItalic, styles.fontSizeNinePt, styles.paddingLeftPointTwoCm]
}, `• ${getTaggedNoteText(note)}`)))) || /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, defaults.noBereavedNotesInEffect)))));